export default __webpack_public_path__ + "static/media/15t.da5a557c.jpg";